<!-- <mat-calendar [(selected)]="selectedDate" (selectedChange)="saveNoteModal.open()" /> -->
<loader [loading]="loading()" text="Loading Calendar">
  <section class="mt-4">
    <loader>
      <div class="row">
        <div class="col-md-4">
          <div class="btn-group">
            <button
              class="btn btn-primary"
              mwlCalendarPreviousView
              [view]="view()"
              [(viewDate)]="viewDate"
              (viewDateChange)="closeOpenMonthViewDay()">
              {{ 'Previous' | appTranslate | async }}
            </button>
            <button class="btn btn-outline-secondary" mwlCalendarToday [(viewDate)]="viewDate">
              {{ 'Today' | appTranslate | async }}
            </button>
            <button
              class="btn btn-primary"
              mwlCalendarNextView
              [view]="view()"
              [(viewDate)]="viewDate"
              (viewDateChange)="closeOpenMonthViewDay()">
              {{ 'Next' | appTranslate | async }}
            </button>
          </div>
        </div>
        <div class="col-md-4 text-center">
          <h3>{{ viewDate() | calendarDate: view() + 'ViewTitle' : 'en' }}</h3>
          <!-- <app-btn type="secondary" text="Add Event" (mclick)="handleEvent('Clicked', null)"></app-btn> -->
        </div>
        <div class="col-md-4 d-flex justify-content-end">
          <div class="btn-group">
            @for (v of calendarViews; track v) {
              <button class="btn btn-{{ v === view() ? '' : 'outline-' }}primary" (click)="setView(v)">
                {{ v | titlecase | appTranslate | async }}
              </button>
            }
          </div>
        </div>
      </div>
      <br />
      <div>
        @switch (view()) {
          @case (CalendarView.Month) {
            <mwl-calendar-month-view
              [viewDate]="viewDate()"
              [events]="events()"
              [refresh]="refresh" 
              [activeDayIsOpen]="activeDayIsOpen"
              (dayClicked)="dayClicked($event.day)"
              (eventClicked)="eventClicked($event)"
              (eventTimesChanged)="eventTimesChanged($event)" />
          }
          @case (CalendarView.Week) {
            <mwl-calendar-week-view
              [viewDate]="viewDate()"
              [events]="events()"
              [refresh]="refresh"
              (eventClicked)="eventClicked($event)"
              (eventTimesChanged)="eventTimesChanged($event)" />
          }
          @case (CalendarView.Day) {
            <mwl-calendar-day-view
              [viewDate]="viewDate()"
              [events]="events()"
              [refresh]="refresh"
              (eventClicked)="eventClicked($event)"
              (eventTimesChanged)="eventTimesChanged($event)" />
          }
        }
      </div>
    </loader>
  </section>
</loader>

<modal-comp
  #saveNoteModal
  header="{{ currentNote() ? 'Edit' : 'Add' }} Event"
  [showFooter]="false"
  width="500px"
  height="auto">
  <ng-template modalBody>
    <save-user-calendar-note
      [note]="currentNote()"
      (done)="refreshEvents(); saveNoteModal.close(); currentNote.set(null)" />
  </ng-template>
</modal-comp>

<modal-comp #viewNoteModal [header]="viewNoteComp.header()!" [showFooter]="false" width="500px" height="auto">

    <view-user-calendar-note body #viewNoteComp [note]="currentNote()" (done)="viewNoteModal.close(); currentNote.set(null)" />

</modal-comp>
